var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b47f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 6.92308,
    x2: 45.108,
    xlinkHref: "#a",
    y1: 20.3548,
    y2: -21.9385
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 9.96923,
    x2: 25.2432,
    xlinkHref: "#a",
    y1: 15.3419,
    y2: -1.57539
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10-5.52285 0-10 4.47715-10 10 0 1.5114.33532 2.9446.93562 4.229l-.71263 4.3955c-.10952.6755.47652 1.2589 1.15151 1.1464l4.35532-.7259c1.29498.6125 2.74258.955 4.27018.955z",
    fill: "url(#b)",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 15.1111v-.7315c0-.3635-.2213-.6903-.5588-.8253l-.904-.3617c-.4293-.1716-.9184.0143-1.1252.4278l-.0787.1574s-1.1111-.2222-2-1.1111-1.1111-2-1.1111-2l.1574-.0787c.4135-.2068.5994-.69594.4278-1.12517l-.3617-.90407c-.135-.33747-.46181-.55876-.82528-.55876h-.73153c-.49092 0-.88889.39797-.88889.88889 0 3.92731 3.1838 7.11111 7.1111 7.11111.4909 0 .8889-.398.8889-.8889z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaWhatsapp);
export default __webpack_public_path__ + "static/media/social-media-whatsapp.468f92d05408395543180f3ceffc1afd.svg";
export { ForwardRef as ReactComponent };